import { TFunction } from 'react-i18next';
import { capitalizeFirstLetter } from 'utils';
import { CurrencyFormater } from 'types/commonTypes';
import { HowToPayEnum } from 'views/shared/HowToPay/type';
import { RadioBtnOption } from 'views/shared/MgmtFeePolicyEnforcer/mgmtPaymentTypeSelector';
import { MgmtFeeTypeEnum } from 'views/shared/types';

const REPLACE_TEXT = '[amount]';

export interface IMgmtOptFeeData {
  amount: number;
  totalDueToday: number;
}

export const getMgmtFeeAndAccruedOptions = ({
  t,
  currencyFormatter,
  annualFeeAmount,
  monthlyFeeAmount,
  accruedFee,
  totalDueTodayAnnualFee,
  totalDueTodayMonthlyFee,
}: {
  t: TFunction<'translation', undefined>;
  currencyFormatter: CurrencyFormater;
  monthlyFeeAmount: number;
  annualFeeAmount: number;
  accruedFee: number;
  totalDueTodayAnnualFee: number;
  totalDueTodayMonthlyFee: number;
}) => {
  const feePaymentPlanOptions: RadioBtnOption<IMgmtOptFeeData>[] = [
    {
      id: MgmtFeeTypeEnum.YEARLY,
      label: 'Annually',
      value: MgmtFeeTypeEnum.YEARLY,
      data: {
        amount: annualFeeAmount,
        totalDueToday: totalDueTodayAnnualFee,
      },
      description: (
        <span className="flex flex-col  space-y-2">
          <span>
            {t('account:feePolicyEnforcerTemplate.annually.text1').replace(
              REPLACE_TEXT,
              currencyFormatter.format(annualFeeAmount),
            )}
          </span>

          <span>{t('account:feePolicyEnforcerTemplate.annually.text2')}</span>

          <span className="flex space-x-2 italic text-xs">{t('account:feePolicyEnforcerTemplate.annually.text3')}</span>
        </span>
      ),
    },
    {
      id: MgmtFeeTypeEnum.MONTHLY,
      label: capitalizeFirstLetter(MgmtFeeTypeEnum.MONTHLY),
      value: MgmtFeeTypeEnum.MONTHLY,
      data: {
        amount: monthlyFeeAmount,
        totalDueToday: totalDueTodayMonthlyFee,
      },
      description: (
        <span className=" text-sm space-y-2  flex flex-col">
          <span>
            {t('account:feePolicyEnforcerTemplate.monthly.text1').replace(
              REPLACE_TEXT,
              currencyFormatter.format(monthlyFeeAmount),
            )}
          </span>

          <span>
            {t('account:feePolicyEnforcerTemplate.monthly.text2').replace(
              REPLACE_TEXT,
              currencyFormatter.format(accruedFee),
            )}
          </span>

          <span className="flex space-x-2 italic text-xs">{t('account:feePolicyEnforcerTemplate.monthly.text3')}</span>
        </span>
      ),
    },
  ];

  return feePaymentPlanOptions;
};

export const getHowToPayMgmtFeeAndAccruedOptions = ({
  currentAmount,
  currencyFormatter,
  selectedMgmtFeeType,
}: {
  t: TFunction<'translation', undefined>;
  currencyFormatter: CurrencyFormater;
  currentAmount: number;
  selectedMgmtFeeType: MgmtFeeTypeEnum;
}) => {
  const options: RadioBtnOption[] = [
    {
      id: HowToPayEnum.CARD,
      label: capitalizeFirstLetter(HowToPayEnum.CARD),
      value: HowToPayEnum.CARD,
      description: (
        <span className=" flex space-x-2">
          <span className="font-medium ">{currencyFormatter.format(currentAmount)}</span>
        </span>
      ),
      data: currentAmount,
    },
    // {
    //   id: HowToPayEnum.PAYMENT_LINK,
    //   label: 'Payment link',
    //   value: HowToPayEnum.PAYMENT_LINK,
    //   description: (
    //     <span className=" flex space-x-2">
    //       <span className="font-medium ">Pay via payment link {currencyFormatter.format(currentAmount)}</span>
    //     </span>
    //   ),
    //   data: currentAmount,
    // },
  ];

  return selectedMgmtFeeType === MgmtFeeTypeEnum.MONTHLY ? [options[0]] : options;
};
